export default "__VITE_ASSET__oFjW$BCE__"